import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from 'moment'
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import "./index.css"
import { loginStatus } from "../../../actions/userActions";


const ListUsers = () => {
  // Get User info from local storage
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  // Get jsonwebtoken from browser storage
  const token = userInfo ? userInfo.token : null
  // Get user email from browser storage
  const userEmail = userInfo ? userInfo.user_email : null

  // State for how many page on the table list
  const [pageNumber, setPageNumber] = useState([])
  // State to show which page of table we are now
  const [currentPage, setCurrentPage] = useState(1)
  // State for activate which page is active and will get blue background
  const [isActive, setIsActive] = useState({ ods_1: true })
  // Pagination setting will send to backend as url query parameter to get club data
  const [pagination, setPagination] = useState({
    search: '',
    page: 1,
    limit: 20
  })

  const [isUpdated, setIsUpdated] = useState(false)

  const { search, page, limit } = pagination

  // State as container or variable to receipt the club data from backend
  const [users, setUsers] = useState([])

  // Config headers for send to backend
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  // Delete State
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)

  // User Data State
  const [userData, setUserData] = useState({ uid: '', name: '' })

  const [userStatus, setUserStatus] = useState([])

  // Data Loading Status State
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  let lastPage = 1

  useEffect(() => {
    const getUsers = async () => {
      try {
        setIsLoading(true)
        const users = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/user?search=${search}&page=${page}&limit=${limit}`, config)
        if (page !== lastPage) {
          setUserStatus([])
        }
        users.data.rows.map(dt => {
          setUserStatus(current => [...current, dt.status])
        })
        setPageNumber(Array(Math.ceil(users.data.count / limit)).fill(0))
        setUsers(users.data.rows)

        lastPage = page
        setTimeout(() => {
          setIsLoading(false)
        }, 100);
      } catch (error) {
        dispatch(loginStatus())
      }
    }
    getUsers()
  }, [search, currentPage, isUpdated])

  const pageOnClick = (val) => {
    setCurrentPage(val)
    setPagination({ ...pagination, page: val })
    setIsActive({ [`ods_${val}`]: true })
  }

  // This function is for move forward when we click Next on pagination
  const onNextPage = () => {
    if (currentPage === pageNumber.length) {
      return
    }
    setCurrentPage(currentPage + 1)
    setPagination({ ...pagination, page: currentPage + 1 })
    setIsActive({ [`ods_${currentPage + 1}`]: true })
  }

  // This function is for move backforward when we click Previous on pagination
  const onPrevPage = () => {
    if (currentPage === 1) {
      return
    }
    setCurrentPage(currentPage - 1)
    setPagination({ ...pagination, page: currentPage - 1 })
    setIsActive({ [`ods_${currentPage - 1}`]: true })
  }

  const onChange = (e) => {
    setCurrentPage(1);
    setIsActive({ "ods_1": true })
    setPagination({ ...pagination, page: 1, search: e.target.value })
  }

  const deleteUser = async () => {
    const user = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/${userData.uid}`)
    toast.success('Delete User Success !', {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 200,
      className: 'saiva-toast',
    })
    setIsUpdated(!isUpdated)
    setPagination({ page: 1, limit: 20, search: '' })
    setDeleteConfirmation(false)
  }

  const deleteUserConfirmation = async (uid, name) => {
    setUserData({ uid, name })
    setDeleteConfirmation(true)
  }

  const changeUserLicense = async (uid, status) => {
    const data = {
      status: !status
    }
    const user = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/license/${uid}`, data)
    setIsUpdated(!isUpdated)
  }

  console.log(users)

  return (
    <div className="container-fluid loaded" style={{ display: "block" }}>
      <ToastContainer />
      <div className="rotating-lines">
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="82"
          visible={isLoading}
        />
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Administer</li>
                <li className="breadcrumb-item active">Manage Users</li>
              </ol>
            </div>
            <h4 className="page-title">Manage Users</h4>
          </div>
        </div>
      </div>
      <div className="form-messages"></div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="app-search search-form float-right">
                <div className="form-group position-relative">
                  <input
                    type="text"
                    name="edit[q]"
                    className="form-control submittable"
                    onChange={onChange}
                    value={search}
                    placeholder="Search by name..."
                  />
                  <span className="fa fa-search search-icon"></span>
                </div>
                <input type="hidden" name="op" value="" />
              </div>
              <h4 className="header-title mb-3 mt-1">Users</h4>
              <table id="tbl0" className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Group</th>
                    <th>Date</th>
                    <th>License</th>
                    <th width="72">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, index) => (
                    <tr key={user.uid}>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.permission_group.group ? user.permission_group.group : ""}</td>
                      <td>{moment.unix(user.createdt).format('YYYY-MM-DD HH:mm')}</td>
                      <td className="text-center">{userEmail !== user.email ? <input onChange={() => changeUserLicense(user.uid, user.status)} type="checkbox" value={user.status} checked={user.status} /> : ""}</td>
                      <td>
                        <Link
                          to={`/users/edit/${user.uid}`}
                          title="Edit"
                        >
                          <i className="icon-button fa fa-border fa-pencil pencil-alt btn-hero"></i>
                        </Link>
                        {userEmail !== user.email ?
                          <a onClick={() => deleteUserConfirmation(user.uid, user.name)} style={{ cursor: "pointer" }}>
                            <i className="icon-button fa fa-border fa-trash trash-alt btn-ghost"></i>
                          </a>
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <a style={{ cursor: 'pointer' }} onClick={onPrevPage} className="page-link" tabIndex="-1">Previous</a>
                </li>
                {pageNumber.map((item, index) => (
                  <li key={index} className={`page-item ${isActive[`ods_${index + 1}`] ? "active" : ""}`}><a style={{ cursor: 'pointer' }} className="page-link" onClick={() => pageOnClick(index + 1)} >{index + 1}</a></li>
                ))}
                <li className={`page-item ${currentPage === pageNumber.length ? "disabled" : ""}`}>
                  <a style={{ cursor: 'pointer' }} onClick={onNextPage} className="page-link">Next</a>
                </li>
              </ul>
              <Link to="/users/add" className="btn button btn-hero">
                <i className="fa fa-fw fa-plus"></i> Add
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        show={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
      >
        <Modal.Header closeButton>
          <h4>Manage Users</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-2">
            <div className="col-12">
              <h4 className="">Are you sure you want to delete user : {userData.name} ?</h4>
            </div>

          </div>
          <div className="row p-2">
            <button onClick={deleteUser} className="btn btn-sm mr-2 btn-hero">Confirm</button>
            <button onClick={() => setDeleteConfirmation(false)} className="btn btn-sm btn-ghost">Cancel</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ListUsers;
